import React from 'react';
import { StaticView } from '../../types/BlockWithViews';
import { ViewContextProvider } from './ViewContext';

export function asView<Embedded>(Component: React.FC<Embedded>) {
  const View = function (props: StaticView<Embedded>) {
    return (
      <ViewContextProvider {...props}>
        <Component {...props.embedded} key={props.href} />
      </ViewContextProvider>
    );
  };
  View.displayName = `As${Component.displayName || Component.name}View`;
  return View;
}
